import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant75() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      cta: 'Получить макет'
    },
    ua: {
      cta: 'Отримати макет'
    },
    en: {
      cta: 'Get a mockup'
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full flex flex-col items-center justify-center px-4 pt-20 pb-12 bg-white" data-id="element-1007">
        <div className="max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-1008">
          <h1 className="text-4xl md:text-6xl lg:text-[5.5rem] font-black leading-[1.2] tracking-tight text-gray-900" data-id="element-1009">
            Создаем уникальные сайты
            <motion.span animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="inline-flex items-center justify-center mx-3 md:mx-5 align-middle w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-blue-400 to-blue-600 rounded-3xl text-4xl md:text-5xl shadow-lg shadow-blue-500/30" data-id="element-1010">
              💻
            </motion.span>
            для клиентов,
            <br data-id="element-1011" />
            нужно оплачивать
            <motion.span animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 2,
            delay: 0.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="inline-flex items-center justify-center mx-3 md:mx-5 align-middle w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-green-400 to-green-600 rounded-3xl text-4xl md:text-5xl shadow-lg shadow-green-500/30" data-id="element-1012">
              💳
            </motion.span>
            только за обслуживание
            <br data-id="element-1013" />
            всего лишь
            <motion.span animate={{
            scale: [1, 1.05, 1]
          }} transition={{
            duration: 2,
            delay: 1,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="inline-flex items-center justify-center mx-3 md:mx-5 align-middle px-8 py-2 bg-gray-900 text-white rounded-3xl text-4xl md:text-6xl font-black shadow-2xl" data-id="element-1014">
              {price}
            </motion.span>
            в месяц
          </h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="mt-16" data-id="element-1015">
            <button onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-2 rounded-2xl px-12 py-6 font-bold text-xl transition-all hover:scale-105 bg-gray-900 text-white shadow-xl" data-id="element-1016">
              {content.cta}
              <ArrowRightIcon className="w-6 h-6 transition-transform group-hover:translate-x-1" data-id="element-1017" />
            </button>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-1018" />
    </>;
}